import request from '@/utils/request'
  export function index(id) {
    return request({
      url: `/assent/${id}/profile`,
      method: 'get',
    })
  }

